import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useActivePortfolioId } from '@/components/PortfolioSelector';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-portfolio rows from /portfolios/contrast, scoped to the active
// portfolio (all rows when viewing "All Portfolios"). Shared by the
// Conviction Snapshot card and the risk banners under Benchmark
// Comparison after the Income by Portfolio card was retired (Sep 2026).
export default function usePortfolioContrastRows() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { activeId } = useActivePortfolioId();

  const fetchRows = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/portfolios/contrast`, { withCredentials: true });
      setRows(Array.isArray(data?.portfolios) ? data.portfolios : []);
    } catch {
      setRows([]);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { fetchRows(); }, [fetchRows]);

  useEffect(() => {
    window.addEventListener('portfolio-changed', fetchRows);
    window.addEventListener('live-prices-tick', fetchRows);
    return () => {
      window.removeEventListener('portfolio-changed', fetchRows);
      window.removeEventListener('live-prices-tick', fetchRows);
    };
  }, [fetchRows]);

  const visibleRows = activeId ? rows.filter((r) => r.portfolio_id === activeId) : rows;
  return { rows: visibleRows, loaded, isAllView: !activeId };
}
